/**
 * Where Your basics lives: once, in the app shell, over whichever page the
 * citizen is on. The URL opens it (`?basics=…`); its code loads the first time
 * it is asked for, and it then stays mounted, so a passport read still in
 * flight when the window closes is discarded rather than stranded.
 */
import { lazy, Suspense, useState } from 'react';

import { useProfileBasicsRoute } from '../hooks/use-profile-basics-route';

const ProfileBasicsDialog = lazy(() =>
  import('./ProfileBasicsDialog').then((module) => ({ default: module.ProfileBasicsDialog }))
);

export function ProfileBasicsHost() {
  const { view, show, close } = useProfileBasicsRoute();
  const [asked, setAsked] = useState(false);
  if (view && !asked) setAsked(true);
  if (!asked) return null;
  return (
    <Suspense fallback={null}>
      <ProfileBasicsDialog view={view} onShow={show} onClose={close} />
    </Suspense>
  );
}
